import { useSelector } from "react-redux";
import RevenueCity from "./Components/SystemFOT/RevenueCity";
import AddStaffModalWindow from "./Modals/SystemFOT/AddStaffModalWindow";
import AddCityModalWindow from "./Modals/AddCityModalWindow";
import MainMenu from "./Components/SystemFOT/MainMenu";
import StaffManagment from "./Modals/SystemFOT/StaffManagment";
import ModalDeletedStaff from "./Modals/SystemFOT/ModalDeletedStaff";
import ModalChoicePeriod from "./Modals/SystemFOT/ModalChoicePeriod";
import Login from "./Modals/Login";
import AddUserModalWindow from "./Modals/AddUserModalWindow";
import UserManagment from "./Modals/UserManagment";
import OtherMenu from "./Modals/OtherMenu";
import ChoiceSystem from "./Modals/ChoiceSystem";
import ChoiceComponentAR from "./Modals/SystemAdvanceReports/ChoiceComponentAR";
import EnteringDataAR from "./Components/SystemAdvanceReports/EnteringDataAR";
import AddArticleED from "./Modals/SystemAdvanceReports/AddArticleED";
import AddArticleAPI from "./Modals/SystemAdvanceReports/AddArticleAPI";
import ArticleManagment from "./Modals/SystemAdvanceReports/ArticleManagment";
import SummaryReports from "./Components/SystemAdvanceReports/SummaryReports";
import MainRevenue from "./Components/SystemRevenue/MainRevenue";


function App() {
  const OpenModal = useSelector(state => state.ModalSlice.OpenModal)

  return (
    <div className="App">
      <div className="App-inner">
        {window.matchMedia('(max-width: 740px)').matches && <OtherMenu/>}
        {OpenModal.OpenSummaryReport && <SummaryReports/>}
        {OpenModal.OpenArticleManagment && <ArticleManagment/>}
        {OpenModal.OpenAddArticleAPI && <AddArticleAPI/>}
        {OpenModal.OpenAddArticleED && <AddArticleED />}
        {OpenModal.OpenEnteringDataAR && <EnteringDataAR />}
        {OpenModal.OpenChoiceSystem && <ChoiceSystem/>}
        {OpenModal.OpenChoiceComponentAR && <ChoiceComponentAR />}
        {OpenModal.OpenLogin && <Login/>}
        {OpenModal.OpenMainMenu && <MainMenu/>}
        {OpenModal.OpenRevenue && <RevenueCity/>}
        {OpenModal.OpenModalAddStaff && <AddStaffModalWindow/>}
        {OpenModal.OpenModalAddCity && <AddCityModalWindow/>}
        {OpenModal.OpenStaffManagment && <StaffManagment/>}
        {OpenModal.OpenDeletedStaff && <ModalDeletedStaff/>}
        {OpenModal.OpenModalAddUser && <AddUserModalWindow/>}
        {OpenModal.OpenChoicePeriod && <ModalChoicePeriod/>}
        {OpenModal.OpenUserManagment && <UserManagment/>}
        {OpenModal.openRevenueModule && <MainRevenue/>}
      </div>
    </div>
  )
}

export default App;
